import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { IBets, IBetsArea } from 'widgets/Roulette/types';
import { isEmpty } from 'ramda';
import { arrayToBets } from 'widgets/Roulette/helpers';

export const rouletteBetRootSelector = (state: IState): IBetsArea =>
  state.rouletteReducer.rouletteBetReducer;

export const placedBetSelector = createSelector(
  rouletteBetRootSelector,
  (state: IBetsArea): IBets => state.bets,
);

export const betsAreaSelector = createSelector(
  rouletteBetRootSelector,
  (state: IBetsArea): IBetsArea => state,
);

export const confirmedBetsSelector = createSelector(
  rouletteBetRootSelector,
  (state: IBetsArea) => state.betsConfirmed,
);

export const summaryBetSelector = createSelector(rouletteBetRootSelector, (state: IBetsArea) => {
  if (state.betsConfirmed.length) {
    return arrayToBets(state.betsConfirmed);
  }
  return state.bets.present;
});

export const isBetsEmptySelector = createSelector(rouletteBetRootSelector, (state: IBetsArea) =>
  isEmpty(state.bets.present),
);
